import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  lengthValidation120,
  maxFileSize,
  notNullOrUndefined,
  required,
} from '../Forms/utils';

import {
  CHECKBOX,
  EXPANDABLE_IMAGE_COMPONENT,
  IMAGE_UPLOAD,
  REACT_SELECT_INPUT,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const DeliveryTypesFormComponent = ({
  countriesOptions,
  isCreate,
  form,
  onSubmit,
  initialValues,
  onLoad,
}) => {
  const { t } = useTransl();

  const iconUrl = initialValues?.icons?.[0]?.url;

  const formData = [
    {
      keyName: 'icon',
      label: t('title.icon'),
      fieldType: EXPANDABLE_IMAGE_COMPONENT,
      src: iconUrl,
      height: '10rem',
      isHidden: !iconUrl,
    },
    {
      keyName: 'name',
      label: t('title.name'),
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'enabled',
      label: t('title.isEnabled'),
      fieldType: CHECKBOX,
      validate: [notNullOrUndefined],
    },
    {
      keyName: 'initialValueForBuildings',
      label: t('title.defaultOnForAll'),
      fieldType: CHECKBOX,
      validate: [notNullOrUndefined],
    },
    {
      keyName: 'countries',
      label: t('title.countriesWithNote'),
      fieldType: REACT_SELECT_INPUT,
      options: countriesOptions,
      multi: true,
      validate: [],
    },

    {
      keyName: 'icons',
      label: t('title.deliveryTypeIcon'),
      fieldType: IMAGE_UPLOAD,
      validate: [maxFileSize],
      isHidden: !isCreate,
    },
    {
      label: t('title.removeIcon'),
      keyName: 'removeIcon',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !iconUrl || true, // not supported by API at this point
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      onLoad={onLoad}
      title={isCreate ? t('delivery.addType') : t('actions.update')}
      backButton
      submitText={t('actions.save')}
    />
  );
};

DeliveryTypesFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  countriesOptions: PropTypes.instanceOf(Array).isRequired,
  isCreate: PropTypes.bool.isRequired,
};

export default DeliveryTypesFormComponent;
